import styled from 'styled-components';

export const TerminalsWpr = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: flex-start;
  font-family: 'Rubik';
  font-weight: 400;
`;

export const Terminals = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &.expand {
    flex-direction: column;
    padding-left: 16px;
  }
`;

export const Source = styled.div`
  &.expandSource {
    flex: 1;
    position: relative;
    padding-bottom: 12px;
  }
`;

export const Label = styled.p`
  white-space: nowrap;
  font-size: 18px;
  font-family: 'Rubik';
  font-weight: 700;
  line-height: 22px;

  &.ellipsesBefore {
    overflow: hidden; 
    width: 110px;
    text-overflow: ellipsis;
  }

  &.ellipsesAfter {
    overflow: hidden; 
    width: 250px;
    text-overflow: ellipsis;
  }
`;

export const SubLabel = styled.p`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  font-family: 'Rubik';
  color: #757575;
  margin-top: 4px;
`;

export const DateTime = styled.p`
  font-size: 12px;
  line-height: 16px;
  font-family: 'Rubik';
  font-weight: 700;
  color: #4a4a4a;
  margin-top: 4px;
`;

export const ExpandedStops = styled.span`
  display: flex;
  width: 50px;
  align-items: flex-start;
  margin: 8px;
  width: unset;
  margin: unset;
  align-items: unset;
  flex-direction: column;
  position: absolute;
  height: calc(100% + 6px);
  top: 8px;
  left: -16px;
`

export const Stops = styled.span`
  display: flex;
  width: 50px;
  align-items: flex-start;
  margin: 8px;
`;

export const From = styled.span`
  height: 6px;
  width: 6px;
  border: 1px solid #4a4a4a;
  border-radius: 50%;
`;

export const ExpandedLine = styled.span`
  flex: 1;
  border: 2px dashed #4a4a4a;
  margin: 4px 2px 4px 1px;
`

export const Line = styled.span`
  flex: 1;
  border-bottom: 2px dashed #4a4a4a;
  margin: 2px 4px;
  border-left: 2px dashed #4a4a4a;
  margin: 4px 2px;
`;

export const To = styled.span`
  height: 6px;
  width: 6px; 
  background-color: #4a4a4a;
  border-radius: 50%;
`;

export const Chevron = styled.span`
  position: relative;
  padding: 12px;
  display: inline-flex;

  &::after {
    content: '';
    position: absolute;
    border: solid #008cff;
    border-width: 0 2px 2px 0;
    padding: 3px;
    display: inline-flex;
    left: 50%;
    top: 50%;
    transform: rotate(45deg);
    transition: all 0.3s linear;
  }

  &.chevronExpand {
    &::after {
      transform: rotate(-135deg);
    }
  }
`;